<template>
    <b-form-group
        :label="config.label"
    >
        <b-textarea v-model="valueModel" :placeholder="config.placeholder"/>
    </b-form-group>
</template>

<script>
export default {
    name: "Textarea",
    props: {
        config: Object,
        value: Array
    },
    computed: {
        valueModel: {
            get() { return this.value.length > 0 ? this.value[0] : '' },
            set (value) { this.$emit('input', [value]); }
        }
    }
}
</script>

<style scoped>

</style>